import { inject, Injectable } from '@angular/core';
import { ApolloService } from './apollo.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EBookService {
  private readonly apolloService = inject(ApolloService);

  downloadEbook(ebook: EbookDownloadModel): Observable<boolean> {
    return this.apolloService.query<boolean>(
      `query DownloadEbook($ebook: DownloadEbookInput!) {
                downloadEbook(downloadEbookInput: $ebook)
            }`,
      'downloadEbook',
      { ebook }
    );
  }
}

export class EbookDownloadModel {
  name: string;
  email: string;
}
